import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/* eslint-disable max-len, react/prop-types */
var Play = function Play(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: "36",
    height: "36",
    viewBox: "0 0 36 36",
    children: [/*#__PURE__*/_jsx("title", {
      children: "Play Button Icon"
    }), /*#__PURE__*/_jsxs("g", {
      "aria-hidden": "true",
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/_jsx("circle", {
        fill: "#FFF",
        cx: "18",
        cy: "18",
        r: "18"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#202020",
        d: "M13 11.386L26.228 18 13 24.614z"
      })]
    })]
  });
};

export default Play;